import React, { useMemo, useState } from "react";

function inArray(v, arr) {
  return Array.isArray(arr) && arr.includes(v);
}

function anyFlagTrue(flags, keys) {
  return keys.some((k) => !!flags[k]);
}

function deriveComplexityFromFTLLTL(value) {
  // value: one of G2 options
  if (inArray(value, ["FTL_0_25_LTL_75_100", "LTL_100"])) return "HIGH";
  if (inArray(value, ["FTL_25_50_LTL_50_75", "FTL_50_75_LTL_25_50"])) return "MEDIUM";
  return "LOW"; // FTL_75_100_LTL_0_25 or FTL_100
}

function sectorLabel(sector) {
  switch (sector) {
    case "LOGISTICS":
      return "Lojistik / Nakliye Hizmetleri";
    case "MANUFACTURING":
      return "Üretim / Sanayi";
    case "DISTRIBUTION":
      return "Dağıtım / Toptan – Perakende";
    case "ECOM_FULFILL":
      return "E-ticaret & Fulfillment (FTL/LTL)";
    default:
      return "Diğer";
  }
}

function volumeLabel(v) {
  const map = {
    "1_50": "1–50",
    "51_200": "51–200",
    "201_1000": "201–1.000",
    "1000_PLUS": "1.000+",
  };
  return map[v] || "-";
}

function ftlltlLabel(v) {
  const map = {
    "FTL_0_25_LTL_75_100": "%0–25 FTL / %75–100 LTL",
    "FTL_25_50_LTL_50_75": "%25–50 FTL / %50–75 LTL",
    "FTL_50_75_LTL_25_50": "%50–75 FTL / %25–50 LTL",
    "FTL_75_100_LTL_0_25": "%75–100 FTL / %0–25 LTL",
    "FTL_100": "%100 FTL",
    "LTL_100": "%100 LTL",
  };
  return map[v] || "-";
}

// -----------------------------
// 2) Engine Config (Questions)
// -----------------------------
const QUESTIONS = [
  {
    id: "G0",
    type: "single",
    text: "Firmanız ağırlıklı olarak hangi alanda faaliyet gösteriyor?",
    options: [
      { value: "LOGISTICS", label: "Lojistik / Nakliye Hizmetleri" },
      { value: "MANUFACTURING", label: "Üretim / Sanayi" },
      { value: "DISTRIBUTION", label: "Dağıtım / Toptan – Perakende" },
      { value: "ECOM_FULFILL", label: "E-ticaret & Fulfillment (FTL/LTL)" },
      { value: "OTHER", label: "Diğer" },
    ],
    onAnswer: (value, ctx) => {
      ctx.setFlags({ SECTOR: value });
    },
    next: () => "G1",
  },
  {
    id: "G1",
    type: "single",
    text: "Aylık ortalama kaç adet yurtiçi sevkiyat yönetiyorsunuz?",
    options: [
      { value: "1_50", label: "1–50" },
      { value: "51_200", label: "51–200" },
      { value: "201_1000", label: "201–1.000" },
      { value: "1000_PLUS", label: "1.000+" },
    ],
    onAnswer: (value, ctx) => {
      if (inArray(value, ["201_1000", "1000_PLUS"])) {
        ctx.setFlags({ YUKSEK_HACIM: true });
      }
    },
    next: () => "G2",
  },
  {
    id: "G2",
    type: "single",
    text: "Yurtiçi sevkiyatlarınız yaklaşık olarak nasıl dağılıyor? (FTL=Komple / LTL=Parsiyel)",
    options: [
      { value: "FTL_0_25_LTL_75_100", label: "%0–25 FTL / %75–100 LTL" },
      { value: "FTL_25_50_LTL_50_75", label: "%25–50 FTL / %50–75 LTL" },
      { value: "FTL_50_75_LTL_25_50", label: "%50–75 FTL / %25–50 LTL" },
      { value: "FTL_75_100_LTL_0_25", label: "%75–100 FTL / %0–25 LTL" },
      { value: "FTL_100", label: "%100 FTL" },
      { value: "LTL_100", label: "%100 LTL" },
    ],
    onAnswer: (value, ctx) => {
      const c = deriveComplexityFromFTLLTL(value);
      ctx.setFlags({ COMPLEXITY: c });
    },
    next: () => "S1",
  },
  {
    id: "S1",
    type: "single",
    // Sektöre göre aynı sorunun metni değişiyor (vitrin)
    textVariants: {
      LOGISTICS: "Yurtiçi taşıma siparişini nasıl oluşturuyorsunuz? (adres, tonaj, tarih, navlun vb.)",
      MANUFACTURING: "Üretimden çıkan ürünler için sevkiyat talebini nasıl oluşturuyorsunuz? (ürün, palet/tonaj, teslim tarihi vb.)",
      DISTRIBUTION: "Mağaza/bayi/müşteri teslimatları için dağıtım planını nasıl oluşturuyorsunuz? (adres, teslim günü–saati vb.)",
      ECOM_FULFILL: "Depodan depoya / depodan mağazaya FTL–LTL sevkiyat talebini nasıl oluşturuyorsunuz? (adres, palet/tonaj, tarih vb.)",
      OTHER: "Yurtiçi sevkiyat talebini nasıl oluşturuyorsunuz?",
    },
    options: [
      { value: "MANUAL", label: "Excel / manuel" },
      { value: "MESSAGING", label: "WhatsApp / e-posta" },
      { value: "ERP_BASIC", label: "ERP var ama nakliyeye/sevkiyata özel ekran yok" },
      { value: "TMS", label: "Nakliye yönetim sistemi üzerinden standart talep/sipariş" },
    ],
    onAnswer: (value, ctx) => {
      if (inArray(value, ["MANUAL", "MESSAGING", "ERP_BASIC"])) {
        ctx.setFlags({ MANUEL_SUREC: true });
      }
    },
    next: () => "S2",
  },
  {
    id: "S2",
    type: "single",
    text: "Oluşturulan sevkiyat/sipariş, taşıyıcıya veya aracı temin eden tedarikçiye nasıl iletiliyor?",
    options: [
      { value: "PHONE", label: "Telefon / yüz yüze" },
      { value: "MSG", label: "WhatsApp / e-posta" },
      { value: "MIXED", label: "Birden fazla kanal birlikte" },
      { value: "SYSTEM", label: "Nakliye yönetim sistemi üzerinden otomatik" },
    ],
    next: () => "T1",
  },
  {
    id: "T1",
    type: "single",
    text: "Taşıyıcıyı veya aracı temin eden tedarikçiyi ağırlıklı olarak nasıl sağlıyorsunuz?",
    options: [
      { value: "CONTRACT", label: "Sürekli sözleşmeli" },
      { value: "SPOT", label: "Spot piyasa" },
      { value: "COOP", label: "Kooperatif / birlik" },
      { value: "DIGITAL", label: "Dijital ağ / sistem üzerinden" },
    ],
    onAnswer: (value, ctx) => {
      if (value === "SPOT") ctx.setFlags({ SPOT_RISK: true });
    },
    next: () => "T2",
  },
  {
    id: "T2",
    type: "single",
    text: "Birden fazla teklif geldiğinde karar nasıl veriliyor?",
    options: [
      { value: "HABIT", label: "Alışkanlık / tecrübe" },
      { value: "PRICE", label: "En uygun fiyat" },
      { value: "FIT_TIME", label: "Araç uygunluğu & teslim süresi" },
      { value: "SYSTEM_COMPARE", label: "Sistem üzerinden karşılaştırarak" },
    ],
    next: () => "F1",
  },
  {
    id: "F1",
    type: "single",
    text: "Sefer durumu (yüklemede – yolda – boşaltmada – tamamlandı) nasıl takip ediliyor?",
    options: [
      { value: "CALLS", label: "Operasyon telefonla takip eder" },
      { value: "DRIVER_CALLS", label: "Şoför aradıkça" },
      { value: "WHATSAPP", label: "WhatsApp üzerinden" },
      { value: "AUTO_STATUS", label: "Nakliye yönetim sistemi otomatik günceller" },
    ],
    next: () => "F2",
  },
  {
    id: "F2",
    type: "single",
    text: "Sefer sırasında gecikme olursa ne oluyor?",
    options: [
      { value: "LEARN_IF_CALL", label: "Şoför ararsa öğreniliyor" },
      { value: "MANUAL_NOTIFY", label: "Operasyon manuel bildiriyor" },
      { value: "NOT_ALWAYS", label: "Her zaman bildirilmez" },
      { value: "SYSTEM_ALERT", label: "Sistem uyarı üretir" },
    ],
    // Gate: COMPLEXITY MEDIUM/HIGH ise Karma Bloğu, değilse Evrak'a
    next: (ctx) => (inArray(ctx.flags.COMPLEXITY, ["HIGH", "MEDIUM"]) ? "C1" : "E1"),
  },

  // Karma / çoklu teslimat bloğu (koşullu)
  {
    id: "C1",
    type: "single",
    text: "Birden fazla teslim noktası olan sevkiyatlarda navlun bedeli nasıl paylaştırılıyor?",
    options: [
      { value: "AVERAGE", label: "Ortalama olarak bölünüyor" },
      { value: "MANUAL", label: "Manuel hesaplanıyor" },
      { value: "EXPERIENCE", label: "Operasyon tecrübesine göre" },
      { value: "SYSTEM_TON_KM", label: "Her noktanın tonajı ve mesafesine göre sistem otomatik hesaplıyor" },
    ],
    next: () => "C2",
  },
  {
    id: "C2",
    type: "single",
    text: "Çoklu teslimatlı sevkiyatlarda aşağıdakilerden hangileri anlık görülebiliyor?",
    options: [
      { value: "OPS_ONLY", label: "Operasyon ekibi" },
      { value: "DELIVERED", label: "Teslim edilen noktalar" },
      { value: "REMAINING", label: "Kalan teslim noktaları" },
      { value: "SYSTEM_ALL", label: "Nakliye yönetim sistemi ile hepsi birlikte" },
    ],
    next: () => "E1",
  },

  // Evrak / Mutabakat / Ödeme (herkese)
  {
    id: "E1",
    type: "single",
    text: "Teslim evraklarını (irsaliye, POD vb.) sürücülerden nasıl topluyorsunuz?",
    options: [
      { value: "PHYSICAL", label: "Fiziki (kargo/elden) topluyoruz" },
      { value: "PHOTO", label: "WhatsApp fotoğraf" },
      { value: "NONE", label: "Evrak toplama süreci yok" },
      { value: "DRIVER_APP", label: "Sürücü mobil uygulaması / sistem üzerinden" },
    ],
    next: () => "E2",
  },
  {
    id: "E2",
    type: "single",
    text: "Bir sefer tamamlandıktan sonra mutabakat süreci nasıl ilerliyor?",
    options: [
      { value: "DOCS_START", label: "Evrak gelince başlıyor" },
      { value: "OPS_CONFIRM", label: "Operasyon teyidiyle ilerliyor" },
      { value: "MANUAL_CHECK", label: "Manuel kontrolle tamamlanıyor" },
      { value: "AUTO_RECON", label: "Nakliye yönetim sistemi seferi otomatik mutabakata alıyor" },
    ],
    onAnswer: (value, ctx) => {
      if (inArray(value, ["DOCS_START", "OPS_CONFIRM", "MANUAL_CHECK"])) {
        ctx.setFlags({ MANUEL_MUTABAKAT: true });
      }
    },
    next: () => "E3",
  },
  {
    id: "E3",
    type: "single",
    text: "Taşıyıcı / tedarikçi ödemeleri nasıl yapılıyor?",
    options: [
      { value: "SINGLE_EFT", label: "Tek tek manuel EFT / Havale" },
      { value: "BULK", label: "Toplu ödeme" },
      { value: "ACCOUNTING", label: "Muhasebe yazılımı üzerinden" },
      { value: "AUTO_PAY", label: "Nakliye yönetim sistemi üzerinden otomatik" },
    ],
    onAnswer: (value, ctx) => {
      if (inArray(value, ["SINGLE_EFT", "BULK"])) {
        ctx.setFlags({ MANUEL_ODEME: true });
      }
    },
    // Gate: CFO bloğu gerekli mi?
    next: (ctx) => {
      const openCFO = anyFlagTrue(ctx.flags, ["YUKSEK_HACIM", "MANUEL_SUREC", "MANUEL_MUTABAKAT", "MANUEL_ODEME"]);
      return openCFO ? "M1" : "R0";
    },
  },

  // CFO (koşullu)
  {
    id: "M1",
    type: "single",
    text: "Sefer / müşteri / güzergâh bazlı kârlılığı ne zaman net görebiliyorsunuz?",
    options: [
      { value: "NO", label: "Net göremiyoruz" },
      { value: "EXCEL", label: "Excel / manuel tablolarla" },
      { value: "PERIODIC", label: "Dönemsel raporlarla" },
      { value: "REALTIME", label: "Nakliye yönetim sistemi üzerinden anlık" },
    ],
    next: () => "M2",
  },
  {
    id: "M2",
    type: "single",
    text: "Operasyon kaynaklı riskleri (gecikme, maliyet artışı, müşteri şikâyeti vb.) ne zaman fark ediyorsunuz?",
    options: [
      { value: "DAYS_LATER", label: "Günler sonra" },
      { value: "OPS_SAYS", label: "Operasyon bildirdiğinde" },
      { value: "REPORT", label: "Rapor geldiğinde" },
      { value: "ALERT", label: "Sistem anlık uyarı üretir" },
    ],
    next: () => "R0",
  },

  // Result screen
  { id: "R0", type: "result" },
];

function getQuestionById(id) {
  return QUESTIONS.find((q) => q.id === id);
}

// -----------------------------
// 3) App
// -----------------------------
export default function Anket() {
  const [flags, setFlagsState] = useState({
    SECTOR: null,
    YUKSEK_HACIM: false,
    COMPLEXITY: "LOW",
    MANUEL_SUREC: false,
    MANUEL_MUTABAKAT: false,
    MANUEL_ODEME: false,
    SPOT_RISK: false,
  });

  const [answers, setAnswers] = useState({});
  const [currentId, setCurrentId] = useState("G0");
  const [history, setHistory] = useState([]); // stack of {id, answerValue}

  const current = useMemo(() => getQuestionById(currentId), [currentId]);

  const progress = useMemo(() => {
    // basit ilerleme: cevaplanan soru sayısı / tahmini 12
    const answeredCount = Object.keys(answers).length;
    const estTotal = 12;
    return Math.min(100, Math.round((answeredCount / estTotal) * 100));
  }, [answers]);

  function setFlags(patch) {
    setFlagsState((prev) => ({ ...prev, ...patch }));
  }

  function getQuestionText(q) {
    if (!q) return "";
    if (q.textVariants) {
      const s = flags.SECTOR || "OTHER";
      return q.textVariants[s] || q.textVariants.OTHER || "";
    }
    return q.text || "";
  }

  function goNext(selectedValue) {
    if (!current || current.type !== "single") return;

    // Save answer
    setAnswers((prev) => ({ ...prev, [current.id]: selectedValue }));
    setHistory((prev) => [...prev, { id: current.id, value: selectedValue }]);

    // Apply effects
    const ctx = { flags, setFlags: (p) => setFlags(p) };
    if (typeof current.onAnswer === "function") {
      current.onAnswer(selectedValue, ctx);
    }

    // Determine next
    const ctxNext = { flags: { ...flags, ...(current.id === "G0" ? { SECTOR: selectedValue } : {}) }, setFlags };
    // Not: bazı flag'ler setState ile async güncellendiği için,
    // next kararlarında doğrudan "selectedValue" ile set edilen bazı şeyleri yukarıda yedirdik.
    // Daha deterministik istersen, tüm engine'i tek state reducer ile yaparız.
    let nextId = null;
    if (typeof current.next === "function") nextId = current.next({ flags: { ...flags, ...deriveImmediateFlagPatch(current.id, selectedValue, flags) } });
    else if (current.next && current.next.default) nextId = current.next.default;

    if (!nextId) nextId = "R0";
    setCurrentId(nextId);
  }

  // Bu fonksiyon: next kararında async state gecikmesini azaltmak için küçük bir "anlık patch"
  function deriveImmediateFlagPatch(qid, value, currentFlags) {
    const patch = {};
    if (qid === "G0") patch.SECTOR = value;
    if (qid === "G1" && inArray(value, ["201_1000", "1000_PLUS"])) patch.YUKSEK_HACIM = true;
    if (qid === "G2") patch.COMPLEXITY = deriveComplexityFromFTLLTL(value);
    if (qid === "S1" && inArray(value, ["MANUAL", "MESSAGING", "ERP_BASIC"])) patch.MANUEL_SUREC = true;
    if (qid === "T1" && value === "SPOT") patch.SPOT_RISK = true;
    if (qid === "E2" && inArray(value, ["DOCS_START", "OPS_CONFIRM", "MANUAL_CHECK"])) patch.MANUEL_MUTABAKAT = true;
    if (qid === "E3" && inArray(value, ["SINGLE_EFT", "BULK"])) patch.MANUEL_ODEME = true;
    return patch;
  }

  function goBack() {
    if (history.length === 0) return;
    const last = history[history.length - 1];
    // Remove last answer
    const newHistory = history.slice(0, -1);
    setHistory(newHistory);

    setAnswers((prev) => {
      const copy = { ...prev };
      delete copy[last.id];
      return copy;
    });

    // Basit yaklaşım: geri gidince flag'leri yeniden hesaplamayacağız (demo için).
    // Prod'da: history üzerinden baştan replay edip flags'i recompute etmek gerekir.
    setCurrentId(last.id);
  }

  function resetAll() {
    setFlagsState({
      SECTOR: null,
      YUKSEK_HACIM: false,
      COMPLEXITY: "LOW",
      MANUEL_SUREC: false,
      MANUEL_MUTABAKAT: false,
      MANUEL_ODEME: false,
      SPOT_RISK: false,
    });
    setAnswers({});
    setHistory([]);
    setCurrentId("G0");
  }

  // Result content (simple rules)
  function buildResult() {
    const sector = sectorLabel(flags.SECTOR);
    const volume = volumeLabel(answers.G1);
    const mix = ftlltlLabel(answers.G2);
    const complexity = flags.COMPLEXITY;

    const strengths = [];
    const opportunities = [];

    // Strengths
    if (answers.F1 === "AUTO_STATUS") strengths.push("Sefer durumları düzenli ve görünür şekilde takip ediliyor.");
    if (answers.S1 === "TMS") strengths.push("Sipariş/sevkiyat talebi standardı oluşmuş görünüyor.");
    if (answers.E3 === "AUTO_PAY") strengths.push("Ödeme süreci otomasyona yakın görünüyor.");

    // Opportunities
    if (flags.MANUEL_SUREC) opportunities.push("Sipariş ve iletişim adımlarında manuel yük yüksek.");
    if (inArray(complexity, ["HIGH", "MEDIUM"])) opportunities.push("Çoklu teslimatlı sevkiyatlarda maliyet ve görünürlük yönetimi kritik.");
    if (flags.MANUEL_MUTABAKAT) opportunities.push("Mutabakat süreci evrak/manuel kontrole bağımlı.");
    if (flags.MANUEL_ODEME) opportunities.push("Ödeme sürecinde manuel adımlar zaman ve risk yaratıyor.");

    // Keep short
    const strengthsFinal = strengths.slice(0, 2);
    const oppFinal = opportunities.slice(0, 3);

    return { sector, volume, mix, complexity, strengths: strengthsFinal, opportunities: oppFinal };
  }

  // UI
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>Nakliye Yönetimi Olgunluk Testi</div>
            <div style={styles.subTitle}>Kısa test • Sektöre göre uyarlanır • Gereksiz soru yok</div>
          </div>
          <div style={styles.progressWrap}>
            <div style={styles.progressLabel}>{progress}%</div>
            <div style={styles.progressBarOuter}>
              {/* JSX içinde template string zorunlu */}
              <div style={{ ...styles.progressBarInner, width: `${progress}%` }} />
            </div>
          </div>
        </div>

        <div style={styles.card}>
          {current?.type === "result" ? (
            <ResultView data={buildResult()} onReset={resetAll} />
          ) : (
            <QuestionView
              question={current}
              questionText={getQuestionText(current)}
              selectedValue={answers[current?.id] || ""}
              onNext={goNext}
              onBack={goBack}
              canBack={history.length > 0}
              onReset={resetAll}
            />
          )}
        </div>

        <div style={styles.footer}>
          <div>Not: Bu demo versiyonudur. Prod’da “Geri” için flag’ler history’den yeniden hesaplanmalıdır.</div>
        </div>
      </div>
    </div>
  );
}

// -----------------------------
// 4) Components
// -----------------------------
function QuestionView({ question, questionText, selectedValue, onNext, onBack, canBack, onReset }) {
  const [local, setLocal] = useState(selectedValue);

  // question değişince local selection reset
  React.useEffect(() => {
    setLocal(selectedValue || "");
  }, [question?.id]); // eslint-disable-line

  return (
    <div>
      <div style={styles.qTitle}>{questionText}</div>

      <div style={styles.options}>
        {question?.options?.map((opt) => (
          <label key={opt.value} style={styles.option}>
            <input
              type="radio"
              name={question.id}
              value={opt.value}
              checked={local === opt.value}
              onChange={(e) => setLocal(e.target.value)}
              style={{ marginRight: 10 }}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>

      <div style={styles.actions}>
        <button onClick={onReset} style={styles.secondaryBtn}>
          Baştan Başla
        </button>

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onBack} disabled={!canBack} style={{ ...styles.secondaryBtn, opacity: canBack ? 1 : 0.5 }}>
            Geri
          </button>
          <button onClick={() => onNext(local)} disabled={!local} style={{ ...styles.primaryBtn, opacity: local ? 1 : 0.6 }}>
            Devam
          </button>
        </div>
      </div>
    </div>
  );
}

function ResultView({ data, onReset }) {
  return (
    <div>
      <div style={styles.qTitle}>Operasyon Olgunluk Özeti</div>

      <div style={styles.resultBlock}>
        <div style={styles.resultTitle}>Operasyon Profili</div>
        <div style={styles.resultText}>
          <div>
            <b>Sektör:</b> {data.sector}
          </div>
          <div>
            <b>Aylık hacim:</b> {data.volume}
          </div>
          <div>
            <b>FTL/LTL:</b> {data.mix}
          </div>
          <div>
            <b>Karmaşıklık:</b> {data.complexity}
          </div>
        </div>
      </div>

      <div style={styles.resultBlock}>
        <div style={styles.resultTitle}>Güçlü Alanlar</div>
        <ul style={styles.ul}>
          {(data.strengths.length ? data.strengths : ["Bu testte güçlü alanlarınız tespit edildi."]).map((s, i) => (
            <li key={i} style={styles.li}>
              {s}
            </li>
          ))}
        </ul>
      </div>

      <div style={styles.resultBlock}>
        <div style={styles.resultTitle}>İyileştirme Potansiyeli</div>
        <ul style={styles.ul}>
          {(data.opportunities.length ? data.opportunities : ["Operasyonunuz genel olarak kontrollü görünüyor."]).map((s, i) => (
            <li key={i} style={styles.li}>
              {s}
            </li>
          ))}
        </ul>
      </div>

      <div style={styles.resultBlock}>
        <div style={styles.resultTitle}>İyi Uygulama Notu</div>
        <div style={styles.resultText}>
          Ölçekli nakliye operasyonları; sevkiyat–takip–evrak–mutabakat–ödeme süreçlerini{" "}
          <b>tek bir nakliye yönetim sistemi</b> üzerinden yönettiğinde operasyonel yük ve finansal belirsizlik ciddi şekilde azalır.
        </div>
      </div>

      <div style={styles.actions}>
        <button onClick={onReset} style={styles.primaryBtn}>
          Tekrar Başlat
        </button>
      </div>
    </div>
  );
}

// -----------------------------
// 5) Styles (simple inline)
// -----------------------------
const styles = {
  page: {
    minHeight: "100vh",
    background: "#0b0b0b",
    color: "#fff",
    padding: 24,
    display: "flex",
    justifyContent: "center",
  },
  container: {
    width: "100%",
    maxWidth: 860,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    alignItems: "center",
    marginBottom: 16,
  },
  title: { fontSize: 20, fontWeight: 700 },
  subTitle: { fontSize: 13, opacity: 0.8, marginTop: 4 },
  progressWrap: { width: 200, textAlign: "right" },
  progressLabel: { fontSize: 12, opacity: 0.85, marginBottom: 6 },
  progressBarOuter: { height: 8, background: "#1e1e1e", borderRadius: 999 },
  progressBarInner: { height: 8, background: "#ff6a3d", borderRadius: 999 },
  card: {
    background: "#111",
    border: "1px solid #222",
    borderRadius: 14,
    padding: 20,
    boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
  },
  qTitle: { fontSize: 18, fontWeight: 700, marginBottom: 14, lineHeight: 1.3 },
  options: { display: "grid", gap: 10, marginBottom: 18 },
  option: {
    display: "flex",
    alignItems: "center",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #222",
    background: "#0f0f0f",
    cursor: "pointer",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    marginTop: 8,
    flexWrap: "wrap",
  },
  primaryBtn: {
    background: "#ff6a3d",
    color: "#000",
    border: "none",
    padding: "10px 14px",
    borderRadius: 10,
    fontWeight: 700,
    cursor: "pointer",
  },
  secondaryBtn: {
    background: "transparent",
    color: "#fff",
    border: "1px solid #333",
    padding: "10px 14px",
    borderRadius: 10,
    cursor: "pointer",
  },
  footer: { marginTop: 14, fontSize: 12, opacity: 0.6 },
  resultBlock: { borderTop: "1px solid #222", paddingTop: 14, marginTop: 14 },
  resultTitle: { fontSize: 14, fontWeight: 800, marginBottom: 8, opacity: 0.95 },
  resultText: { fontSize: 13, lineHeight: 1.55, opacity: 0.92 },
  ul: { margin: 0, paddingLeft: 18 },
  li: { marginBottom: 6, fontSize: 13, lineHeight: 1.4, opacity: 0.92 },
};
